import Axios from 'axios';
import { stringify } from 'qs';

import { Session } from '@/models/session';
import config from '@/utils/config';

export default (session?: Session) =>
  Axios.create({
    baseURL: config.getAPIAddress(),
    headers:
      (session && {
        Authorization: session.user.token,
        'selected-company': session.company?.publicKey,
      }) ||
      {},
    paramsSerializer: (params) =>
      stringify(params, {
        encode: false,
        arrayFormat: 'brackets',
        skipNulls: false,
        strictNullHandling: true,
      }),
  });
